<template>
  <WebChapterTemplate
    page-title="中国传播学大会"
    section-label="学科建设"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
  >
    <div class="conference-manual">
      <section
        v-for="section in sections"
        :key="section.title"
        class="conference-section"
      >
        <div class="conference-section__header">
          <h2 class="conference-section__title">{{ section.title }}</h2>
          <p class="conference-section__summary">{{ section.summary }}</p>
        </div>

        <div
          class="conference-grid"
          :class="`conference-grid--${section.columns || 2}`"
        >
          <article
            v-for="card in section.cards"
            :key="card.title"
            class="conference-card"
          >
            <figure class="conference-card__figure">
              <img :src="card.src" :alt="card.title" loading="lazy" />
            </figure>
            <div class="conference-card__body">
              <h3 class="conference-card__title">{{ card.title }}</h3>
              <p class="conference-card__text">{{ card.description }}</p>
            </div>
          </article>
        </div>
      </section>
    </div>
  </WebChapterTemplate>
</template>

<script>
import WebChapterTemplate from '@/components/WebChapterTemplate.vue';

export default {
  name: 'LanhuZhongguochuanboxuedahui',
  components: {
    WebChapterTemplate
  },
  data() {
    return {
      sectionRoute: '/lanhu_xuekeyukeyan',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      sections: [
        {
          title: '全国传播学研讨会',
          summary: '从 1982 年到 1999 年，新闻研究所持续参与和推动全国传播学研讨会的组织与交流。',
          columns: 2,
          cards: [
            {
              title: '1982 年第一次全国传播学研讨会',
              src: require('./assets/html/seminar-1982.jpg'),
              description: '1982 年 11 月 23 日至 25 日，新闻研究所倡议发起的中国大陆第一次全国性的传播学研讨会在新闻研究所召开。'
            },
            {
              title: '1993 年第三次全国传播学研讨会',
              src: require('./assets/html/seminar-1993.jpg'),
              description: '1993 年 5 月，新闻研究所与厦门大学在厦门联合举办第三次全国传播学研讨会。'
            },
            {
              title: '1995 年第四次全国传播学研讨会',
              src: require('./assets/html/seminar-1995.jpg'),
              description: '1995 年 6 月，新闻研究所与四川广播电视厅、四川省社会科学院联合在成都举办第四次全国传播学研讨会。'
            },
            {
              title: '1997 年第五次全国传播学研讨会',
              src: require('./assets/html/seminar-1997.jpg'),
              description: '1997 年 4 月，新闻研究所与杭州大学联合举办第五次全国传播学研讨会。'
            },
            {
              title: '1999 年第六次全国传播学研讨会',
              src: require('./assets/html/seminar-1999.jpg'),
              description: '1999 年 11 月，新闻与传播研究所与复旦大学新闻学院、北京日报社联合在复旦大学举行第六次全国传播学研讨会。'
            }
          ]
        },
        {
          title: '中国传播学大会',
          summary: '2010 年后，中国传播学大会持续扩展学术合作网络，形成更大范围的学界交流平台。',
          columns: 2,
          cards: [
            {
              title: '2010 年第十一届中国传播学大会',
              src: require('./assets/html/conference-2010.jpg'),
              description: '2010 年 7 月，中国新闻文化促进会传播学分会、新闻与传播研究所、北京大学新闻与传播学院共同主办的第十一届中国传播学大会在北京大学举行，中国社会科学院常务副院长王伟光出席开幕式并致辞。'
            },
            {
              title: '2016 年第十三届中国传播学大会',
              src: require('./assets/html/conference-2016.jpg'),
              description: '2016 年 10 月，中国传播学会、新闻与传播研究所与南京大学新闻传播学院联合主办的第十三届中国传播学大会在南京举行，所长唐绪军研究员做主旨演讲。'
            },
            {
              title: '2018 年第十四届中国传播学大会',
              src: require('./assets/html/conference-2018.jpg'),
              description: '2018 年 10 月，中国传播学会、新闻与传播研究所与重庆大学新闻学院联合主办的第十四届中国传播学大会在重庆举行。'
            }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped>
.conference-manual {
  display: grid;
  gap: 32px;
}

.conference-section {
  padding: 26px;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.18);
  background:
    linear-gradient(140deg, rgba(248, 242, 233, 0.84), rgba(255, 255, 255, 0) 42%),
    linear-gradient(180deg, #fff, rgba(253, 250, 246, 0.96));
  box-shadow: 0 14px 30px rgba(59, 41, 17, 0.05);
}

.conference-section__header {
  margin-bottom: 24px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(179, 145, 101, 0.16);
}

.conference-section__title {
  margin: 0;
  color: #f25c19;
  font-size: 26px;
  line-height: 1.4;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
  font-weight: 700;
}

.conference-section__summary {
  margin: 10px 0 0;
  color: #6b5b4b;
  font-size: 16px;
  line-height: 1.8;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.conference-grid {
  display: grid;
  gap: 20px;
}

.conference-grid--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.conference-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.16);
  background: #fff;
  box-shadow: 0 10px 24px rgba(45, 33, 16, 0.05);
}

.conference-card__figure {
  margin: 0;
  background: #f8f4ee;
}

.conference-card__figure img {
  display: block;
  width: 100%;
  height: auto;
}

.conference-card__body {
  padding: 18px 18px 20px;
}

.conference-card__title {
  margin: 0 0 8px;
  color: #2f2a25;
  font-size: 20px;
  line-height: 1.5;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 600;
}

.conference-card__text {
  margin: 0;
  color: #4c433a;
  font-size: 17px;
  line-height: 1.9;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

@media (max-width: 1024px) {
  .conference-grid--2 {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .conference-section {
    padding: 18px;
  }

  .conference-section__title {
    font-size: 24px;
  }

  .conference-card__title {
    font-size: 18px;
  }

  .conference-card__text,
  .conference-section__summary {
    font-size: 16px;
    line-height: 1.8;
  }
}
</style>
